<template>
  <div class="management-bd tb" v-if="funcView.bankFlow_list">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item>
          <el-button v-if="funcView.bankFlow_import" type="primary" @click="onImport">
            <i class="el-icon-plus"></i>
            {{ funcView.bankFlow_import }}
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="funcView.bankFlow_batch_writeOff" type="primary" @click="onWriteOff">
            <i class="el-icon-plus"></i>
            {{ funcView.bankFlow_batch_writeOff }}
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="funcView.bankFlow_download" type="primary" @click="onDownloadTpl">
            <i class="icon icon-xiazai"></i>
            {{ funcView.bankFlow_download }}
          </el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button
            v-if="funcView.bankFlow_sync"
            type="primary"
            @click="onSyncBtn"
          >
            <i class="icon icon-refresh"></i>
            {{ funcView.bankFlow_sync }}({{ $t('page_bankFlow_zan_wu_jie_kou') }})
          </el-button>
        </el-form-item> -->
        <el-form-item style="float: right; margin-right: 0" v-if="funcView.bankFlow_export_unWrittenOff">
          <el-button type="primary" style="vertical-align: top" @click="onExportUnWrittenOff ">
            <i class="icon icon-daochu"></i>
            {{ funcView.bankFlow_export_unWrittenOff }}
          </el-button>
        </el-form-item>
        <el-form-item style="float: right" v-if="funcView.bankFlow_export">
          <el-button class="table-set" style="vertical-align: top" @click="onExportTable">
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>

        <!-- 配置项 -->
        <el-form-item style="float: right" :class="{ 'mr-0': !funcView.bankFlow_export || !funcView.bankFlow_export_unWrittenOff }">
          <custom-column :code="tableCode" v-model="tableColumn"></custom-column>
        </el-form-item>
        <!-- 搜索项 -->
        <el-form-item style="float: right">
          <search-input v-model="formSearch.search" :placeholder="$t('fms_bankFlow.liu_shui_hao')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
      <el-form :inline="true" label-position="top">
        <!-- 交易日，我方银行账号，对方账户名称，对方银行账号 -->
        <el-form-item :label="$t('fms_bankFlow.jiao_yi_ri')">
          <custom-date-picker
            v-model="formSearch.dataTimes"
            type="daterange"
            align="right"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="pickerOptionDisAfter"
            style="width: 100%"
          ></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('fms_bankFlow.wfyhzh')">
          <el-input v-model="formSearch.sellerAccount"></el-input>
        </el-form-item>
        <el-form-item :label="$t('fms_bankFlow.dfzhmc')">
          <el-input v-model="formSearch.buyerName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('fms_bankFlow.dfyhzh')">
          <el-input v-model="formSearch.buyerAccount"></el-input>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table
        index
        v-loading="isLoading"
        :data="bankcardList"
        :column="tableColumn"
        @filter="filterChange"
        @sort="sortChange"
        height="100%"
        :slots="['sellerTradeCode', 'totalAmount', 'action']"
      >
        <template v-slot:totalAmount="scope">
          <span>{{ `${scope.row.sellerTradeType}` === '0' ? '-' : '' }}{{ scope.row.totalAmount }}</span>
        </template>
        <template v-slot:sellerTradeCode="scope">
          <span class="cell-link" @click="onDetailsBtn(scope.row)" v-if="funcView.bankFlow_details">{{ scope.row.sellerTradeCode }}</span>
          <div v-else @click="watchEvent(scope.row)">{{ scope.row.sellerTradeCode }}</div>
        </template>
        <template v-slot:action="scope">
          <el-button type="text" size="mini" @click="onDeleteBtn(scope.row.sellerTradeId)" v-if="funcView.bankFlow_delete && !scope.row.sellerTradeState">{{ funcView.bankFlow_delete }}</el-button>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <!--详情-->
    <banl-flow-detail-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false"></banl-flow-detail-dialog>
    <!-- 导入流水 -->
    <bank-flow-batch-dialog v-if="dialogVisible1" :model="dialogModel1" @close="dialogVisible1 = false" @success="getBankFlowList"></bank-flow-batch-dialog>
    <!-- 批量核销 -->
    <bank-flow-batch-writeOff-dialog v-if="dialogVisible2" @close="dialogVisible2 = false" @success="getBankFlowList"></bank-flow-batch-writeOff-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';
// import bankcardAddressDialog from './children/bank_flow_dialog.vue';
import bankFlowBatchDialog from './children/bank_flow_batch_dialog.vue';
import banlFlowDetailDialog from './children/banl_flow_detail_dialog.vue';
import bankFlowBatchWriteOffDialog from './children/bank_flow_batch_writeOff_dialog.vue';

export default {
  name: 'bankFlow',
  mixins: [resetFormSearchMixins],
  components: { banlFlowDetailDialog, bankFlowBatchDialog, bankFlowBatchWriteOffDialog },
  data() {
    return {
      tableCode: 'bank_flow',
      formSearch: {
        pageSize: 20,
        pageNum: 1,
        search: '',
        dataTimes: '',
        tradeTimeStart: '',
        tradeTimeEnd: '',
        sellerAccount: '', // 我方银行账号
        buyerAccount: '', // 对方银行账号
        buyerName: '', // 对方账户名称
      },
      bankcardList: [],
      tableColumn: [],
      totalRows: null,
      // 详情
      dialogVisible: false,
      dialogModel: {},
      // 入库
      dialogVisible1: false,
      dialogModel1: {},
      // 核销
      dialogVisible2: false,
      link: null,
    };
  },
  mounted() {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getTableColumn();
    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });

    this.getBankFlowList();
  },
  methods: {
    getReqData() {
      this.formSearch.tradeTimeStart = this.formSearch.dataTimes && this.formSearch.dataTimes[0] ? this.formSearch.dataTimes[0] : undefined;
      this.formSearch.tradeTimeEnd = this.formSearch.dataTimes && this.formSearch.dataTimes[1] ? this.formSearch.dataTimes[1] : undefined;
      const ret = {
        ...this.formSearch,
      };

      delete ret.dataTimes;

      return ret;
    },
    // 获取银行卡
    getBankFlowList: function () {
      const reqData = this.getReqData();
      this.isLoading = true;
      this.$getJSON(apis.tradeSellerPage, reqData).then((res) => {
        this.isLoading = false;
        // this.bankcardList = res.data.records;

        this.bankcardList = res.data.list || [];
        this.totalRows = res.data.total;
      });
    },
    // 导入流水
    onImport: function () {
      this.dialogVisible1 = true;
    },
    // 模板下载
    onDownloadTpl: function () {
      this.$exportFlie(apis.tradeSellerDownloadTemplate);
    },
    // 导入流水
    onWriteOff: function () {
      this.dialogVisible2 = true;
    },
    // 新增
    onSyncBtn: function () {},
    // 详情
    onDetailsBtn: function (row) {
      this.dialogVisible = true;
      this.dialogModel.title = this.$t('fms_bankFlow.yhlsxq');
      this.dialogModel.data = row;
    },
    // 删除
    onDeleteBtn: function (sellerTradeId) {
      const tips = this.$t('fms_bankFlow.nqdyscxzdjyjlm');
      this.$showConfirm(tips)
        .then(() => {
          this.$postJSON(`${apis.tradeSellerDelete}/${sellerTradeId}`).then(() => {
            this.$message({
              message: this.$t('Common.com_delete_success'),
              type: 'success',
            });
            this.getBankFlowList();
          });
        })
        .catch(() => {});
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getBankFlowList();
    },
    // 数据导出
    onExportTable: function () {
      const reqData = this.getReqData();
      this.$exportFlie(apis.tradeSellerExport, reqData).then(() => {});
    },
    // 导出未核销账单
    onExportUnWrittenOff: function () {
      const reqData = this.getReqData();
      this.$exportFlie(apis.tradeSellerUnVerifyExport, reqData).then(() => {});
    },
  },
};
</script>

<style lang="scss">
@import '../../../style/colors.scss';

.fiance-bankcard-bd {
  margin: 16px 16px 0 16px;
  background: #fff;
  .bankcard {
    h2 {
      font-size: 16px;
      padding-left: 32px;
      height: 56px;
      line-height: 56px;
      border: 1px solid #e9e9e9;
    }
    .bankcard-body {
      padding: 0px 0 32px 32px;
      background-color: #fff;
      display: flex;
      flex-direction: column;
      p {
        font-size: 14px;
        height: 22px;
        line-height: 22px;
        margin-top: 20px;
        color: rgba(0, 0, 0, 0.45);
      }
      ul {
        display: flex;
        flex-flow: wrap;
        li.card {
          margin: 20px 20px 0 0;
          height: 198px;
          width: 360px;
          background-color: #fff;
          border: 1px solid rgba(217, 217, 217, 1);
          // padding: 20px 0 0 20px;
          position: relative;
          border: 1px solid rgba(228, 228, 228, 1);
          .type {
            height: 56px;
            border-bottom: 1px solid rgba(217, 217, 217, 1);
            padding: 0 16px 0 24px;
            display: flex;
            align-items: center;
            background: rgba(245, 252, 255, 1);
            .logo {
              display: inline-block;
              width: 32px;
              height: 32px;
              flex: 0 0 32px;
              background-color: #262626;
            }
            p {
              margin: 0 0 0 20px;
              flex: 1;
              color: rgba(0, 0, 0, 0.85);
              // line-height: 56px
            }
            span {
              width: 52px;
              height: 26px;
              flex: 0 0 52px;
              font-size: 14px;
              color: #fff;
              line-height: 26px;
              text-align: center;
              background: rgba(247, 181, 0, 1);
            }
          }
          .content {
            height: 142px;
            padding-top: 40px;
            text-align: center;
            position: relative;
            color: rgba(0, 0, 0, 0.85);
            font-size: 24px;
            .operation {
              position: absolute;
              right: 16px;
              bottom: 16px;
              color: $main-color;
              height: 28px;
              a {
                margin-left: 20px;
                font-size: 12px;
                cursor: pointer;
              }
            }
          }
        }
        li.add {
          margin: 20px 0 0 0;
          width: 198px;
          height: 198px;
          text-align: center;
          background: #f5fcff;
          border: 1px solid rgba(217, 217, 217, 1);
          cursor: pointer;
          .add-liaison {
            font-size: 36px;
            color: rgba(0, 0, 0, 0.45);
            display: block;
            margin-top: 69px;
          }
          span {
            font-style: 14px;
            color: rgba(0, 0, 0, 0.45);
            margin-top: 10px;
            line-height: 22px;
          }
        }
      }
    }
  }
}
</style>
